class PeterhanunSku1Purchase extends HTMLElement {
  connectedCallback() {
    const productJson = this.querySelector("[data-product-json]");
    if (!productJson) {
      this.product = { variants: [] };
      this.variants = [];
      this.selected = null;
      this.selectedFit = null;
      this.gallery = [];
      this.galleryIndex = 0;
      this.addons = new Map();
      this.gifts = new Map();
      this.bindFaq();
      this.bindDialogs();
      this.bindCarousels();
      this.bindProductVideos();821

      this.bindMotion();
      return;
    }
    this.product = JSON.parse(productJson.textContent);
    this.variants = this.product.variants || [];
    this.selected =
      this.variants.find((v) => v.id === Number(this.dataset.initialVariant)) ||
      this.variants[0];
    this.selectedFit = null;
    this.gallery = [...this.querySelectorAll("[data-gallery-image]")];
    this.galleryIndex = 0;
    this.addons = new Map();
    this.gifts = new Map();
    this.purchaseQuantity = 1;
    this.bindGallery();
    this.bindVariants();
    this.bindPurchaseQuantity();
    this.bindAddons();
    this.bindFaq();
    this.bindDialogs();
    this.bindCarousels();
    this.bindProductVideos();
    this.bindSticky();
    this.bindCart();
    this.bindMotion();
    this.bindActionVideos();
    this.bindPixelControls();
    this.bindFounder();
    this.startFomo();
    this.update();
    this.bindEqualOptionWidths();
  }
  bindEqualOptionWidths() {
    if (!this.hasAttribute("data-equalize-option-widths")) return;
    const equalize = () => {
      this.querySelectorAll(".sizes").forEach((group) => {
        const buttons = [...group.querySelectorAll(":scope > .size")];
        if (!buttons.length) return;
        group.style.removeProperty("--sku2-option-width");
        const widest = Math.ceil(
          Math.max(...buttons.map((button) => button.getBoundingClientRect().width)),
        );
        group.style.setProperty("--sku2-option-width", `${widest}px`);
      });
    };
    requestAnimationFrame(equalize);
    document.fonts?.ready.then(equalize);
    this.equalOptionWidthsOnResize = equalize;
    addEventListener("resize", this.equalOptionWidthsOnResize, { passive: true });
  }
  bindFounder() {
    const carousel = this.querySelector("[data-founder-carousel]");
    if (!carousel) return;
    const slides = [...carousel.querySelectorAll(".founder-slide")];
    const dots = [...carousel.querySelectorAll("[data-founder-dot]")];
    if (!slides.length) return;
    let index = 0;
    let timer;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
      dots.forEach((dot, i) => dot.classList.toggle("is-active", i === index));
      carousel.style.setProperty("--founder-progress", `${((index + 1) / slides.length) * 100}%`);
    };
    const restart = () => {
      clearInterval(timer);
      if (!matchMedia("(prefers-reduced-motion: reduce)").matches)
        timer = setInterval(() => show(index + 1), 5200);
    };
    carousel.querySelector("[data-founder-prev]")?.addEventListener("click", () => { show(index - 1); restart(); });
    carousel.querySelector("[data-founder-next]")?.addEventListener("click", () => { show(index + 1); restart(); });
    dots.forEach((dot, i) => dot.addEventListener("click", () => { show(i); restart(); }));
    carousel.addEventListener("mouseenter", () => clearInterval(timer));
    carousel.addEventListener("mouseleave", restart);
    carousel.addEventListener("focusin", () => clearInterval(timer));
    carousel.addEventListener("focusout", restart);
    show(0);
    restart();
  }
  money(cents) {
    const requestedCurrency = String(this.dataset.currency || "USD").toUpperCase();
    const currency = requestedCurrency === "XXX" ? "USD" : requestedCurrency;
    return new Intl.NumberFormat(this.dataset.locale || "en-US", {
      style: "currency",
      currency,
    }).format((cents || 0) / 100);
  }
  bindGallery() {
    this.querySelector("[data-prev]")?.addEventListener("click", () =>
      this.showMedia(this.galleryIndex - 1),
    );
    this.querySelector("[data-next]")?.addEventListener("click", () =>
      this.showMedia(this.galleryIndex + 1),
    );
    this.querySelectorAll("[data-thumb]").forEach((b, i) =>
      b.addEventListener("click", () => this.showMedia(i)),
    );
  }
  showMedia(index) {
    if (!this.gallery.length) return;
    this.galleryIndex = (index + this.gallery.length) % this.gallery.length;
    this.gallery.forEach((x, i) => (x.hidden = i !== this.galleryIndex));
    this.querySelectorAll("[data-thumb]").forEach((x, i) =>
      x.setAttribute("aria-current", i === this.galleryIndex),
    );
    const mediaCount = this.querySelector("[data-media-count]");
    if (mediaCount) {
      mediaCount.textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
    }
  }
  bindVariants() {
    this.querySelectorAll("[data-option-value]").forEach((btn) =>
      btn.addEventListener("click", () => {
        const position = Number(btn.dataset.optionPosition);
        this.querySelectorAll(`[data-option-position="${position}"]`).forEach(
          (x) => x.setAttribute("aria-pressed", "false"),
        );
        btn.setAttribute("aria-pressed", "true");
        const chosen = [
          ...this.querySelectorAll('[data-option-value][aria-pressed="true"]'),
        ]
          .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
          .map((x) => x.dataset.optionValue);
        let match = this.variants.find((v) =>
          v.options.every((o, i) => o === chosen[i]),
        );
        if (!match) {
          match = this.variants.find(
            (v) => v.available && v.options[position - 1] === btn.dataset.optionValue,
          );
          if (match) {
            match.options.forEach((value, index) => {
              this.querySelectorAll(`[data-option-position="${index + 1}"]`).forEach(
                (option) => option.setAttribute(
                  "aria-pressed",
                  String(option.dataset.optionValue === value),
                ),
              );
            });
          }
        }
        if (match) {
          this.selected = match;
          this.update();
          if (match.featured_media?.position)
            this.showMedia(match.featured_media.position - 1);
          const url = new URL(window.location.href);
          url.searchParams.set("variant", match.id);
          history.replaceState({}, "", url);
        }
      }),
    );
  }
  bindPurchaseQuantity() {
    const setQuantity = (quantity) => {
      this.purchaseQuantity = Math.max(1, Number(quantity || 1));
      this.querySelectorAll("[data-purchase-quantity]").forEach((option) => {
        const preset = Number(option.dataset.purchaseQuantity || 1);
        const selected = preset === 4 ? this.purchaseQuantity >= 4 : preset === this.purchaseQuantity;
        option.setAttribute("aria-pressed", String(selected));
        option.setAttribute("aria-checked", String(selected));
      });
      this.update();
    };
    this.querySelectorAll("[data-purchase-quantity]").forEach((button) =>
      button.addEventListener("click", () => {
        setQuantity(button.dataset.purchaseQuantity);
      }),
    );
    this.querySelector("[data-quantity-minus]")?.addEventListener("click", () => setQuantity(this.purchaseQuantity - 1));
    this.querySelector("[data-quantity-plus]")?.addEventListener("click", () => setQuantity(this.purchaseQuantity + 1));
  }
  bindAddons() {
    this.querySelectorAll("[data-addon]").forEach((row) => {
      const box = row.querySelector("input[type=checkbox]");
      const select = row.querySelector("[data-addon-variant]");
      const image = row.querySelector(".product-mini-image");
      const price = row.querySelector("[data-addon-price]");
      const compare = row.querySelector("[data-addon-compare]");
      const dot = row.querySelector("[data-addon-dot]");
      const key = row.dataset.addonKey || row.dataset.variantId;
      const variantOptions = Array.from(select?.options || []);
      const imageCache = new Map();
      const preloadOption = (option) => {
        const url = option?.dataset.image;
        if (!url) return Promise.resolve();
        if (imageCache.has(url)) return imageCache.get(url);
        const loader = new Image();
        loader.decoding = "async";
        loader.fetchPriority = "low";
        const ready = new Promise((resolve) => {
          loader.addEventListener("load", resolve, { once: true });
          loader.addEventListener("error", resolve, { once: true });
        });
        imageCache.set(url, ready);
        loader.src = url;
        if (loader.complete) return Promise.resolve();
        return ready;
      };
      const preloadAllOptions = () => variantOptions.forEach(preloadOption);
      const warmNearbyOptions = () => variantOptions.slice(0, 3).forEach(preloadOption);
      if ("requestIdleCallback" in window)
        window.requestIdleCallback(warmNearbyOptions, { timeout: 1500 });
      else window.setTimeout(warmNearbyOptions, 800);
      select?.addEventListener("focus", preloadAllOptions, { once: true });
      select?.addEventListener("pointerdown", preloadAllOptions, { once: true });
      const sync = () => {
        const option = select?.selectedOptions?.[0];
        if (!option) return;
        row.dataset.variantId = option.value;
        row.dataset.price = option.dataset.price || "0";
        row.dataset.available = option.dataset.available || "false";
        if (price) price.textContent = this.money(Number(row.dataset.price));
        const comparePrice = Number(option.dataset.compare || 0);
        if (compare) {
          compare.textContent = this.money(comparePrice);
          compare.hidden = !comparePrice || comparePrice <= Number(row.dataset.price);
        }
        if (image && option.dataset.image) {
          const nextImage = option.dataset.image;
          preloadOption(option).then(() => {
            if (select?.selectedOptions?.[0]?.dataset.image !== nextImage) return;
            image.removeAttribute("srcset");
            image.src = nextImage;
            image.alt = option.textContent.trim();
          });
        }
        if (dot && option.dataset.image)
          dot.style.backgroundImage = `url(${JSON.stringify(option.dataset.image)})`;
        if (box?.checked && row.dataset.available !== "false")
          this.addons.set(key, {
            id: Number(row.dataset.variantId),
            quantity: 1,
            price: Number(row.dataset.price || 0),
          });
        else this.addons.delete(key);
        this.update();
      };
      box?.addEventListener("change", () => {
        sync();
      });
      select?.addEventListener("change", sync);
      sync();
    });
  }
  bindFaq() {
    this.querySelectorAll(".ph-rest-faq-button").forEach((btn) =>
      btn.addEventListener("click", () =>
        btn.setAttribute(
          "aria-expanded",
          btn.getAttribute("aria-expanded") !== "true",
        ),
      ),
    );
  }
  bindDialogs() {
    this.querySelectorAll("[data-dialog-open]").forEach((btn) =>
      btn.addEventListener("click", () =>
        this.querySelector(
          `#${CSS.escape(btn.dataset.dialogOpen)}`,
        )?.showModal(),
      ),
    );
    this.querySelectorAll("[data-dialog-close]").forEach((btn) =>
      btn.addEventListener("click", () => btn.closest("dialog")?.close()),
    );
    this.querySelectorAll("dialog").forEach((dialog) =>
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      }),
    );
  }
  bindCarousels() {
    this.querySelectorAll("[data-carousel]").forEach((carousel) => {
      if (carousel.dataset.carouselReady === "true") return;
      const track = carousel.querySelector("[data-carousel-track]");
      if (!track) return;
      carousel.dataset.carouselReady = "true";
      const getStep = () => {
        const card = track.firstElementChild;
        if (!card) return track.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      carousel
        .querySelector("[data-carousel-prev]")
        ?.addEventListener("click", () =>
          track.scrollBy({
            left: -getStep(),
            behavior: "smooth",
          }),
        );
      carousel
        .querySelector("[data-carousel-next]")
        ?.addEventListener("click", () =>
          track.scrollBy({ left: getStep(), behavior: "smooth" }),
        );
    });
  }
  bindProductVideos() {
    const cards = [...this.querySelectorAll("[data-ph-video-card]")];
    const viewer = this.querySelector("[data-ph-video-viewer]");
    const player = viewer?.querySelector("[data-ph-video-player]");
    if (!cards.length || !viewer || !player) return;
    const progress = viewer.querySelector("[data-ph-video-progress]");
    const caption = viewer.querySelector("[data-ph-video-caption]");
    const volume = viewer.querySelector("[data-ph-video-volume]");
    let activeIndex = 0;
    let swipeStart = null;
    let didSwipe = false;

    if (progress) progress.innerHTML = cards.map(() => "<i></i>").join("");

    const show = (nextIndex) => {
      activeIndex = (nextIndex + cards.length) % cards.length;
      const preview = cards[activeIndex].querySelector("video");
      if (!preview) return;
      player.pause();
      player.innerHTML = preview.innerHTML;
      if (preview.currentSrc) player.src = preview.currentSrc;
      if (preview.poster) player.poster = preview.poster;
      player.muted = false;
      player.loop = false;
      player.controls = !matchMedia("(max-width: 767px)").matches;
      player.load();
      if (caption) caption.textContent = preview.closest("[data-ph-video-card]")?.dataset.videoCaption || preview.closest("[data-ph-video-card]")?.dataset.videoHeading || "";
      volume?.setAttribute("aria-label", "Mute video");
      progress?.querySelectorAll("i").forEach((bar, index) => {
        bar.classList.toggle("is-active", index === activeIndex);
        bar.classList.toggle("is-complete", index < activeIndex);
        bar.style.setProperty("--ph-video-progress", "0%");
      });
      player.play().catch(() => {});
    };

    const close = () => {
      player.pause();
      player.removeAttribute("src");
      player.innerHTML = "";
      player.load();
      viewer.hidden = true;
      viewer.setAttribute("aria-hidden", "true");
      document.documentElement.style.removeProperty("overflow");
      document.documentElement.classList.remove("ph-video-open");
    };

    const open = (card) => {
      viewer.hidden = false;
      viewer.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      document.documentElement.classList.add("ph-video-open");
      show(cards.indexOf(card));
    };

    cards.forEach((card) => {
      card.addEventListener("click", () => open(card));
      card.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        open(card);
      });
      const preview = card.querySelector("video");
      if (preview) {
        preview.muted = true;
        preview.loop = true;
        preview.playsInline = true;
        preview.autoplay = true;
        preview.play().catch(() => {});
      }
    });
    viewer.querySelectorAll("[data-ph-video-close]").forEach((button) =>
      button.addEventListener("click", close),
    );
    viewer.querySelector("[data-ph-video-prev]")?.addEventListener("click", () => show(activeIndex - 1));
    viewer.querySelector("[data-ph-video-next]")?.addEventListener("click", () => show(activeIndex + 1));
    viewer.querySelector(".ph-video-viewer__more")?.addEventListener("click", () => {
      player.controls = !player.controls;
    });
    viewer.querySelector("[data-ph-video-add]")?.addEventListener("click", async () => {
      const addButton = this.querySelector("[data-primary-cta]");
      if (!addButton || addButton.disabled) return;
      close();
      const added = await this.addToCart(addButton);
      if (added) document.dispatchEvent(new CustomEvent("cart:open"));
    });
    viewer.querySelector("[data-ph-video-product]")?.addEventListener("click", () => {
      close();
      this.querySelector("[data-primary-cta]")?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    volume?.addEventListener("click", () => {
      player.muted = !player.muted;
      volume.setAttribute("aria-label", player.muted ? "Unmute video" : "Mute video");
    });
    player.addEventListener("click", () => {
      if (!matchMedia("(max-width: 767px)").matches) return;
      if (didSwipe) { didSwipe = false; return; }
      if (player.paused) player.play().catch(() => {});
      else player.pause();
    });
    player.addEventListener("timeupdate", () => {
      if (!player.duration) return;
      progress?.querySelector("i.is-active")?.style.setProperty(
        "--ph-video-progress",
        `${Math.min(100, (player.currentTime / player.duration) * 100)}%`,
      );
    });
    player.addEventListener("ended", () => show(activeIndex + 1));
    const panel = viewer.querySelector(".ph-video-viewer__panel");
    panel?.addEventListener("pointerdown", (event) => {
      if (!matchMedia("(max-width: 767px)").matches || event.target.closest("button")) return;
      swipeStart = { x: event.clientX, y: event.clientY };
      didSwipe = false;
    });
    panel?.addEventListener("pointerup", (event) => {
      if (!swipeStart) return;
      const dx = event.clientX - swipeStart.x;
      const dy = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dy) < 45 || Math.abs(dy) <= Math.abs(dx)) return;
      didSwipe = true;
      show(dy < 0 ? activeIndex + 1 : activeIndex - 1);
    });
    panel?.addEventListener("pointercancel", () => { swipeStart = null; });
    viewer.querySelector("[data-ph-video-share]")?.addEventListener("click", async () => {
      const shareData = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) await navigator.share(shareData);
        else await navigator.clipboard?.writeText(shareData.url);
      } catch (error) {
        if (error?.name !== "AbortError") console.warn("Unable to share product", error);
      }
    });
    this.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !viewer.hidden) close();
      if (event.key === "ArrowLeft" && !viewer.hidden) show(activeIndex - 1);
      if (event.key === "ArrowRight" && !viewer.hidden) show(activeIndex + 1);
    });
  }
  bindSticky() {
    const bar = this.querySelector("[data-sticky]");
    if (!bar) return;
    if (this.classList.contains("ph-rest-pixel-page")) {
      if (matchMedia("(max-width: 760px)").matches) {
        bar.classList.remove("is-visible", "is-active");
        bar.setAttribute("aria-hidden", "true");
        return;
      }
      const buybox = this.querySelector(".buybox");
      this.stickyScroll = () => {
        const active = !!buybox && buybox.getBoundingClientRect().bottom < 100;
        bar.classList.toggle("is-visible", active);
        bar.classList.toggle("is-active", active);
        bar.setAttribute("aria-hidden", String(!active));
      };
      this.stickyScroll();
      addEventListener("scroll", this.stickyScroll, { passive: true });
      return;
    }
    const buy = this.querySelector("[data-primary-cta]");
    if (!buy) return;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle("is-visible", !entry.isIntersecting);
        bar.classList.toggle("is-active", !entry.isIntersecting);
        bar.setAttribute("aria-hidden", String(entry.isIntersecting));
      },
      { threshold: 0.05 },
    );
    this.observer.observe(buy);
  }
  bindPixelControls() {
    this.querySelectorAll("[data-fit-choice]").forEach((button) =>
      button.addEventListener("click", () => {
        this.querySelectorAll("[data-fit-choice]").forEach((item) => {
          item.setAttribute("aria-pressed", "false");
          item.setAttribute("aria-checked", "false");
        });
        button.setAttribute("aria-pressed", "true");
        button.setAttribute("aria-checked", "true");
        this.selectedFit = {
          label: button.dataset.fitChoice,
          productId: Number(button.dataset.fitProduct || 0),
          variantId: Number(button.dataset.fitVariant || 0),
          price: Number(button.dataset.fitPrice || 0),
          compare: Number(button.dataset.fitCompare || 0),
          available: button.dataset.fitAvailable !== "false",
        };
        const label = this.querySelector("[data-fit-label]");
        if (label) label.textContent = button.dataset.fitChoice;
        this.update();
      }),
    );
    this.querySelector('[data-fit-choice][aria-pressed="true"]')?.click();
    const panel = this.querySelector(".reviews-panel");
    this.querySelector(".ph-rest-review-collapse")?.addEventListener(
      "click",
      () => {
        panel?.classList.toggle("is-open");
        const em = panel?.querySelector(".reviews-toggle em");
        if (em)
          em.textContent = panel.classList.contains("is-open") ? "⌃" : "⌄";
      },
    );
    this.querySelector(".ph-rest-review-more")?.addEventListener(
      "click",
      (event) => {
        const area = event.currentTarget.closest(".reviews-expand");
        area?.classList.toggle("show-more");
        event.currentTarget.textContent = area?.classList.contains("show-more")
          ? "Less −"
          : "More +";
      },
    );
    this.querySelectorAll(".media-frame video").forEach((video) => {
      if (video.closest(".action-section")) return;
      video.addEventListener("click", () =>
        video.paused ? video.play() : video.pause(),
      );
    });
    this.querySelectorAll(".fullscreen").forEach((button) =>
      button.addEventListener("click", () =>
        button.closest(".lab-media")?.requestFullscreen?.(),
      ),
    );
    this.querySelectorAll(".table-scroll").forEach((track) =>
      track.addEventListener("scroll", () => {
        const max = track.scrollWidth - track.clientWidth;
        const indicator = track.parentElement?.querySelector(
          ".scroll-indicator i",
        );
        if (indicator)
          indicator.style.transform = `translateX(${max ? (track.scrollLeft / max) * 300 : 0}%)`;
      }),
    );
  }
  bindMotion() {
    this.motionObserver = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          entry.target.classList.toggle(
            "ph-rest-in-view",
            entry.isIntersecting,
          );
          entry.target.querySelectorAll("video").forEach((video) => {
            if (video.closest(".action-section")) return;
            if (entry.isIntersecting && video.muted)
              video.play().catch(() => {});
            else video.pause();
          });
        }),
      { threshold: 0.2 },
    );
    this.querySelectorAll(".ph-rest-section,.ph-rest-proof,.reveal").forEach(
      (section) => {
        section.classList.add("ph-rest-reveal");
        this.motionObserver.observe(section);
      },
    );
    this.querySelectorAll(
      ".ph-rest-card-media video,.ph-rest-expert video",
    ).forEach((video) =>
      video.addEventListener("click", () =>
        video.paused ? video.play() : video.pause(),
      ),
    );
    this.querySelectorAll(".ph-rest-comparison-wrap,.ph-rest-products").forEach(
      (track) => {
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          track.style.setProperty(
            "--ph-scroll-progress",
            `${max ? (track.scrollLeft / max) * 100 : 0}%`,
          );
        };
        track.addEventListener("scroll", update, { passive: true });
        update();
      },
    );
    const review = this.querySelector(".ph-rest-review-summary");
    if (review) {
      review.classList.add("is-open");
      const toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "ph-rest-review-toggle";
      toggle.textContent = "More +";
      toggle.addEventListener("click", () => {
        review.classList.toggle("show-more");
        toggle.textContent = review.classList.contains("show-more")
          ? "Less −"
          : "More +";
      });
      review.append(toggle);
    }
  }
  bindActionVideos() {
    const section = this.querySelector(".action-section");
    const videos = section ? [...section.querySelectorAll("video")] : [];
    if (!section || !videos.length) return;
    const load = (video) => {
      if (!video || video.dataset.loaded === "true") return;
      video.querySelectorAll("source[data-src]").forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute("data-src");
      });
      video.load();
      video.dataset.loaded = "true";
    };
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) videos.forEach((video) => {
        load(video);
        video.play().catch(() => {});
      });
      else videos.forEach((video) => video.pause());
    }, { rootMargin: "200px 0px", threshold: 0.3 }).observe(section);
  }
  bindCart() {
    this.querySelectorAll("[data-cart-button]").forEach((btn) =>
      btn.addEventListener("click", () => this.addToCart(btn)),
    );
  }
  async addToCart(btn) {
        
    const linked =
      this.selectedFit?.variantId &&
      this.selectedFit.productId !== Number(this.product.id);
    const available = linked
      ? this.selectedFit.available
      : this.selected?.available;
    if (!available) return false;
    const bundleId = this.addons.size || this.gifts.size
      ? `peterhanun-${this.product.id}-${Date.now().toString(36)}-${
          globalThis.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)
        }`
      : "";
    const bundleProperties = (role) =>
      bundleId
        ? {
            "_bundle_id": bundleId,
            "_bundle_role": role,
          }
        : {};    const items = [
      {
        id: linked ? this.selectedFit.variantId : this.selected.id,
        quantity: this.purchaseQuantity || 1,
        properties: {
          "_sku1_bundle": "Yes",
          "_sku1_pillowcase_id": String([...this.gifts.values()].find((gift) => /pillowcase/i.test(gift.tier))?.id || ""),
          "_sku1_eye_mask_id": String([...this.gifts.values()].find((gift) => /eye|sleep mask/i.test(gift.tier))?.id || this.dataset.sku1EyeMaskId || ""),
          Fit:
            this.selectedFit?.label ||
            this.querySelector("[data-fit-label]")?.textContent ||
            "",
          ...bundleProperties("main"),
        },
      },
      ...[...this.addons.values()].map(({ id, quantity }) => ({
        id,
        quantity,
        properties: bundleProperties("addon"),
      })),
      ...[...this.gifts.values()].map(({ id, quantity, tier }) => ({
        id,
        quantity,
        properties: {
          "_Peterhanun SKU-1 free gift": "Yes",
          "_sku1_bundle": "Yes",
          "_Gift tier": tier,
          ...bundleProperties("gift"),
          "_gift_type": /eye|sleep mask/i.test(tier)
            ? "eye-mask"
            : /pillowcase/i.test(tier)
              ? "pillowcase"
              : `gift-${id}`,
        },
      })),
    ];
    btn.disabled = true;
    try {
      const cartSectionIds = [
        ...new Set(
          [...document.querySelectorAll("cart-items-component[data-section-id]")]
            .map((node) => node.dataset.sectionId)
            .filter(Boolean),
        ),
      ];
      const cartAddUrl = window.theme?.routes?.cartAdd || "/cart/add.js";
      const res = await fetch(cartAddUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items,
          sections: cartSectionIds,
          sections_url: window.location.pathname,
        }),
      });
      const response = await res.json();
      if (!res.ok || response.status) throw new Error(response.description || response.message || "cart");
      document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
        bubbles: true,
        detail: {
          product: response,
          addToCartBtn: btn,
        },
      }));
      if (window.theme?.settings?.cartType === "page") {
        window.location = window.theme?.routes?.cartPage || "/cart";
        return true;
      }
        btn.querySelector("[data-cta-label]").textContent = "Added to cart";
      return true;
    } catch (e) {
      btn.querySelector("[data-cta-label]").textContent = "Please try again";
      return false;
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        this.update();
      }, 1400);
    }
  }
  startFomo() {
    const root = this.querySelector(".fomo");
    if (!root || root.classList.contains("fomo-rotator") || root.querySelector(".fomo-track")) return;
    root.querySelector("[data-fomo]")?.remove();
    const message = root.textContent.trim();
    root.textContent = "";
    const track = document.createElement("div");
    track.className = "fomo-track";
    const first = document.createElement("span");
    first.textContent = message;
    const duplicate = document.createElement("span");
    duplicate.textContent = message;
    duplicate.setAttribute("aria-hidden", "true");
    track.append(first, duplicate);
    root.append(track);
  }
  update() {
    if (!this.selected) return;
    const linked =
      this.selectedFit?.variantId &&
      this.selectedFit.productId !== Number(this.product.id);
    const basePrice = linked ? this.selectedFit.price : this.selected.price;
    const baseCompare = linked
      ? this.selectedFit.compare
      : this.selected.compare_at_price;
    const available = linked
      ? this.selectedFit.available
      : this.selected.available;
    const quantity = this.purchaseQuantity || 1;
    const discountRate = quantity >= 4 ? 0.15 : quantity >= 2 ? 0.10 : 0;
    const productTotalBeforeDiscount = basePrice * quantity;
    const productTotal = Math.round(productTotalBeforeDiscount * (1 - discountRate));
    const total =
      productTotal + [...this.addons.values()].reduce((s, x) => s + x.price, 0);
    this.querySelectorAll("[data-current-price]").forEach(
      (x) => (x.textContent = this.money(basePrice)),
    );
    this.querySelectorAll("[data-total-price]").forEach(
      (x) => (x.textContent = this.money(total)),
    );
    this.querySelectorAll("[data-compare-price]").forEach((x) => {
      x.textContent = this.money(baseCompare);
      x.hidden = !baseCompare || baseCompare <= basePrice;
    });
    this.querySelectorAll("[data-cta-label]").forEach(
      (x) => (x.textContent = available ? "Add to Cart" : "Sold Out"),
    );
    this.querySelectorAll("[data-cart-button]").forEach(
      (x) => (x.disabled = !available),
    );
    this.selected.options.forEach((value, index) => {
      const label = this.querySelector(`[data-selected-option="${index + 1}"]`);
      if (label) label.textContent = value;
    });
    const quantityValue = this.querySelector("[data-quantity-value]");
    if (quantityValue) quantityValue.textContent = String(quantity);
    const displaySize = String(this.selected.options[0] || "").includes("36") ? "King" : "Standard";
    const displaySupport = this.selected.options[1] || "";
    const summary = this.querySelector("[data-sku1-summary]");
    if (summary) summary.textContent = `${displaySize} · ${displaySupport} · Qty ${quantity}`;
    const unitPrice = this.querySelector("[data-sku1-unit-price]");
    if (unitPrice) unitPrice.textContent = `${this.money(Math.round(productTotal / quantity))} each`;
    const summaryPrice = this.querySelector("[data-sku1-summary-price]");
    if (summaryPrice) summaryPrice.textContent = this.money(productTotal);
    const summaryCompare = this.querySelector("[data-sku1-summary-compare]");
    if (summaryCompare) {
      summaryCompare.textContent = this.money(productTotalBeforeDiscount);
      summaryCompare.hidden = discountRate === 0;
    }
    const savings = this.querySelector("[data-sku1-savings]");
    if (savings) savings.textContent = discountRate ? `Save ${this.money(productTotalBeforeDiscount - productTotal)}` : "";
    const stickyThumb = this.querySelector(".sticky-thumb");
    const selectedImage = this.selected.featured_image?.src || this.selected.featured_image;
    if (stickyThumb && selectedImage) stickyThumb.src = selectedImage;
    this.gifts.clear();
    const pillowcaseId = Number(
      String(this.selected.options[0] || "").includes("36")
        ? this.dataset.sku1PillowcaseKingId
        : this.dataset.sku1PillowcaseStandardId,
    );
    const eyeMaskId = Number(this.dataset.sku1EyeMaskId || 0);
    if (pillowcaseId) this.gifts.set(`pillowcase-${pillowcaseId}`, { id: pillowcaseId, quantity, tier: "100% Cotton Pillowcase" });
    
    const maskQuantity = Math.floor(quantity / 2);
    if (eyeMaskId && maskQuantity > 0 && this.dataset.sku1EyeMaskAvailable !== "false") {
      this.gifts.set(`eye-mask-${eyeMaskId}`, { id: eyeMaskId, quantity: maskQuantity, tier: "22 Momme Silk Sleep Mask" });
    }
    
    const giftContext = this.querySelector("[data-sku1-gift-context]");
    if (giftContext) giftContext.textContent = `With your ${quantity} pillow${quantity === 1 ? "" : "s"}`;
    const pillowcaseCount = this.querySelector("[data-sku1-pillowcase-count]");
    if (pillowcaseCount) pillowcaseCount.textContent = String(quantity);
    const pillowcasePlural = this.querySelector("[data-sku1-pillowcase-plural]");
    if (pillowcasePlural) pillowcasePlural.textContent = "";
    const maskGift = this.querySelector("[data-sku1-mask-gift]");
    if (maskGift) maskGift.hidden = maskQuantity === 0;
    const maskCount = this.querySelector("[data-sku1-mask-count]");
    if (maskCount) maskCount.textContent = String(maskQuantity);
    const maskPlural = this.querySelector("[data-sku1-mask-plural]");
    if (maskPlural) maskPlural.textContent = "";
  }
  disconnectedCallback() {
    clearInterval(this.fomoTimer);
    this.observer?.disconnect();
    this.motionObserver?.disconnect();
    if (this.stickyScroll) removeEventListener("scroll", this.stickyScroll);
    if (this.equalOptionWidthsOnResize)
      removeEventListener("resize", this.equalOptionWidthsOnResize);
  }
}
if (!customElements.get("peterhanun-sku-1-purchase"))
  customElements.define("peterhanun-sku-1-purchase", PeterhanunSku1Purchase);
